import { createStore, combineReducers, applyMiddleware } from 'redux';
import {
  files, filesFiltered, isFileLoading, pageParam, users, appInfo, adhocInfo,
  userInfo, reviewInfo, groupInfo, reviewAssignInfo, loginInfo, searchInfo
} from './reducers';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const reducers = {
  pageParam, files, filesFiltered, isFileLoading, users, appInfo, adhocInfo,
  userInfo, reviewInfo, groupInfo, reviewAssignInfo, loginInfo, searchInfo };
const rootReducer = combineReducers(reducers);

export const configureStore = () => createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
)
